import React from 'react';
import { HeroSection } from './HeroSection';
import { ProblemSection } from './ProblemSection';
import { OpportunitySection } from './OpportunitySection';
import { AudienceSection } from './AudienceSection';
import { ValueSection } from './ValueSection';
import { TestimonialsSection } from './TestimonialsSection';
import { OriginSection } from './OriginSection';
import { Footer } from './Footer';
export function LandingPage() {
  return <main className="w-full min-h-screen bg-cream selection:bg-slate selection:text-cream" data-id="element-44">
      <HeroSection data-id="element-45" />
      <ProblemSection data-id="element-46" />
      <OpportunitySection data-id="element-47" />
      <AudienceSection data-id="element-48" />
      <ValueSection data-id="element-49" />
      <TestimonialsSection data-id="element-50" />
      <OriginSection data-id="element-51" />
      <Footer data-id="element-52" />
    </main>;
}